export const ALL_LABELS_MUST_HAVE_VALID_PARAMETER = 'all_labels_must_have_valid_parameter';

export const LABEL_CONSISTENCY_CHECK_CODES = [ALL_LABELS_MUST_HAVE_VALID_PARAMETER] as const;
export type LabelConsistencyCheckCodes = (typeof LABEL_CONSISTENCY_CHECK_CODES)[number];
